<script>
    import { tick, beforeUpdate } from 'svelte'
    import Stepper from './Stepper.svelte'
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'
    export let currentStep = 0
    export let allowNext, allowBack
    const currentTab = writable(currentStep)
    const tabData = writable([])
    const events = writable({})
    // const parentProps = writable({})
    let startIndex = -1
    setContext('events', events) // Eventos por Tab
    setContext('currentTab', currentTab) // Id del Tab activo
    setContext('tabData', tabData) // Contexto de props
    setContext('setIndex', {
        // Asignador
        index: () => {
            startIndex += 1
            return startIndex
        },
    })
    beforeUpdate(async () => {
        await tick()
        $currentTab = currentStep
    })
    if (currentStep === undefined) {
        $currentTab = 0
    }
    $: currentStep = $currentTab
    $: breakPoints = $tabData?.map(({ label }) => ({ label })) || []
    $: allowNext = $currentTab >= 0 && $currentTab < breakPoints.length - 1
    $: allowBack = $currentTab > 0

    $: if (currentStep != -1) {
        $events[currentStep]?.load()
    }
</script>

<div class="container">
    {#if breakPoints?.length > 1}
        <div class="head">
            <Stepper bind:current={$currentTab} {breakPoints} />
        </div>
    {/if}
    <div class="content">
        {#if $$slots.header}
            <slot name="header" />
        {/if}
        <slot />
    </div>
    {#if $$slots.footer}
        <div class="footer">
            <slot name="footer" />
        </div>
    {/if}
    {#if $$slots.submit && $currentTab === breakPoints.length - 1}
        <div class="submit">
            <slot name="submit" />
        </div>
    {/if}
</div>

<style>
    .container {
        display: flex;
        padding: 0;
        flex-direction: column;
        gap: 25px;
    }
    .content {
        position: relative;
        widows: 100%;
        height: fit-content;
        margin: 0;
        padding: 0;
    }
    .head {
        /* box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2), 0px -1px 1px rgba(0, 0, 0, 0.02);
        background: white;
        border-radius: 8px; */
        padding: 0;
        margin: 0;
    }
    .footer,
    .submit {
        position: relative;
        widows: 100%;
        height: fit-content;
        margin: 0;
        padding: 0;
    }
</style>
